/**
 * LookDoor — the pen pill on a look: "change this one" (plan 2026_09_23_pack_stage_coda.md
 * § Decided 3). A real link to the wall armed on that picture; `onFollow` runs on the click, before
 * the navigation, for the house's tracking. A client-side navigation (`Link`), so the tracking call
 * is not cut short by a document unload.
 *
 * The house renders it only where the wall would honour it (the house has a wall, `travel.
 * cellsTravel` holds, the visitor may arm). It sits bottom-right over the pager zones; the house
 * moves its corner tag left while the door is present.
 */
import {Link} from 'react-router'

import {Pen} from '@core/wall/ui/Ghost'
import styles from './StagePieces.module.scss'

export interface LookDoorProps {
    href: string
    label: string
    onFollow?: () => void
}

export function LookDoor({href, label, onFollow}: LookDoorProps) {
    return (
        <Link to={href} className={styles.lookDoor} onClick={onFollow}>
            <span className={styles.doorPen} aria-hidden="true"><Pen /></span>
            {label}
        </Link>
    )
}
